import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { consume } from '@lit/context'
import {
  activeQuotationContext,
  NotFetchedYet,
  updateQuotationLineContext
} from 'components/ordering/quotation/components/context/quotation-context.js'
import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { isQuotationDTO } from 'components/ordering/quotation/components/is-quotation-dto.js'
import { UpdateQuotationLinePayload } from 'components/ordering/quotation/api/requests/update-quotation-line.js'

@customElement('csc-quotation-quantity')
export class CSCQuotationQuantity extends LitElement {
  @consume({ context: activeQuotationContext, subscribe: true })
  private quotation!: QuotationDTO | NotFoundError | NotFetchedYet

  @consume({ context: updateQuotationLineContext })
  private updateQuotationLine!: (payload: UpdateQuotationLinePayload) => Promise<void>

  @property({ type: Number, reflect: true, attribute: 'quotation-id' })
  quotationId!: number

  @property({ type: Number, reflect: true, attribute: 'line-id' })
  lineId!: number

  private async updateLine(quantity: number) {
    if (!(isQuotationDTO(this.quotation))) {
      return
    }

    const payload = {
      quotationId: this.quotation.id,
      lineId: this.lineId,
      quantity: quantity,
    }
    await this.updateQuotationLine(payload)
  }

  private get quantity() {
    if (isQuotationDTO(this.quotation)) {
      const line = this.quotation.quotationLines.find(line => line.id === this.lineId)
      if (line) {
        return line.quantity
      }
    }
    return 0
  }

  override render() {
    return html`
      <cse-text-input
        type="number"
        name="quantity"
        label="Quantity"
        value="${this.quantity}"
        @change="${(event: Event) => this.updateLine(parseInt((event.target as HTMLInputElement).value))}"
      >
      </cse-text-input>
    `
  }
}
